import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Chip,
  Stack,
  IconButton,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const COLORS = {
  navy: '#123072',
  open: '#f5c842',
  collab: '#5ac8f6',
  closed: '#4ade80',
  textMuted: '#6b7896',
  border: '#e3e6ef',
};

const statusColor = (status) => {
  if (status === 'open') return COLORS.open;
  if (status === 'collaboration') return COLORS.collab;
  if (status === 'closed') return COLORS.closed;
  return COLORS.textMuted;
};

const IssueDetailDialog = ({ issue, open, onClose }) => {
  if (!issue) return null;

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
        <Typography sx={{ fontWeight: 700, color: COLORS.navy, fontSize: 16 }}>
          Issue {issue.id}
        </Typography>
        <IconButton size="small" onClick={() => onClose(false)}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.25}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip
              label={(issue.status || '').toUpperCase()}
              size="small"
              sx={{ bgcolor: statusColor(issue.status), fontWeight: 600, height: 22 }}
            />
            <Chip label={issue.escalation || '—'} size="small" variant="outlined" />
          </Stack>
          <Box>
            <Typography sx={{ fontSize: 12, color: COLORS.textMuted }}>Root Cause</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{issue.title || '—'}</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: 12, color: COLORS.textMuted }}>Action Plan</Typography>
            <Typography sx={{ fontSize: 13 }}>{issue.actionPlan || '—'}</Typography>
          </Box>
          <Stack direction="row" spacing={3}>
            <Box>
              <Typography sx={{ fontSize: 12, color: COLORS.textMuted }}>Plant</Typography>
              <Typography sx={{ fontSize: 13 }}>{issue.site || '—'}</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: 12, color: COLORS.textMuted }}>Dealer</Typography>
              <Typography sx={{ fontSize: 13 }}>{issue.dealerName || issue.dealer || '—'}</Typography>
            </Box>
          </Stack>
          <Stack direction="row" spacing={3}>
            <Box>
              <Typography sx={{ fontSize: 12, color: COLORS.textMuted }}>MTD Actual</Typography>
              <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{issue.actual ?? '—'}</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: 12, color: COLORS.textMuted }}>MTD Target</Typography>
              <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{issue.mtd_target ?? '—'}</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: 12, color: COLORS.textMuted }}>Responsible</Typography>
              <Typography sx={{ fontSize: 13 }}>{issue.owner || 'Unassigned'}</Typography>
            </Box>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} variant="contained" sx={{ bgcolor: COLORS.navy }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IssueDetailDialog;
